import { IGlobalReducerState } from "Store/Base/interface/IGlobalReducerState";

const getImgsOnErrorControl = (state: IGlobalReducerState) => state.helper.imgsOnErrorControl;
const getShowPreferencesModal = (state: IGlobalReducerState) => state.helper.showPreferencesModal;

export { getImgsOnErrorControl, getShowPreferencesModal };
